import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Tabs Slider (Thumbs)
const tabsSwiper = new Swiper('.bc-tabs-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    slideToClickedSlide: true,
});

// Content Slider (Main)
const contentSwiper = new Swiper('.bc-content-swiper', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    autoHeight: false,
    speed: 600,
    allowTouchMove: false,
    thumbs: {
        swiper: tabsSwiper,
    },
});

// -------------------------
// ⭐ DISABLE / ENABLE ARROWS FUNCTION
// -------------------------
function updateArrows() {
    const prevBtns = document.querySelectorAll('.arrow-prev');
    const nextBtns = document.querySelectorAll('.arrow-next');

    const isFirst = contentSwiper.activeIndex === 0;
    const isLast = contentSwiper.activeIndex === contentSwiper.slides.length - 1;

    prevBtns.forEach(btn => {
        if (isFirst) {
            btn.classList.add('swiper-button-disabled');
            btn.setAttribute('disabled', true);
        } else {
            btn.classList.remove('swiper-button-disabled');
            btn.removeAttribute('disabled');
        }
    });

    nextBtns.forEach(btn => {
        if (isLast) {
            btn.classList.add('swiper-button-disabled');
            btn.setAttribute('disabled', true);
        } else {
            btn.classList.remove('swiper-button-disabled');
            btn.removeAttribute('disabled');
        }
    });
}

// First load par call
updateArrows();

// Slide change par call
contentSwiper.on('slideChange', () => {
    updateArrows();
    tabsSwiper.slideTo(contentSwiper.activeIndex);
});


// -------------------------
// ⭐ ARROWS CONTROL BOTH SLIDERS
// -------------------------
document.querySelectorAll('.arrow-next').forEach(btn => {
    btn.addEventListener('click', () => {
        contentSwiper.slideNext();
    });
});

document.querySelectorAll('.arrow-prev').forEach(btn => {
    btn.addEventListener('click', () => {
        contentSwiper.slidePrev();
    });
});


// -------------------------
// ⭐ TABS CLICK → SLIDE CHANGE
// -------------------------
document.querySelectorAll('.bc-tabs-swiper .bc-slide').forEach((slide, index) => {

    slide.addEventListener('click', () => {
        contentSwiper.slideTo(index);
        tabsSwiper.slideTo(index);
        updateArrows();
    });

    slide.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            contentSwiper.slideTo(index);
            tabsSwiper.slideTo(index);
            updateArrows();
        }
    });
});

